import { AuthProvider, UserIdentity } from "react-admin";
import DescopeSdk from '@descope/web-js-sdk';
import { storeReturnUrl } from '../return-url.utils';

export const descopeAuthProvider = (descope: ReturnType<typeof DescopeSdk>): AuthProvider => {
  let sessionToken = "";
  let user = {};

  return {
    async login(params) {
      const response = await descope.me();
      //   const response = await descope.flow.start("sign-up-or-in");
      return Promise.resolve();
    },
    async logout() {
      // Store current URL before logout for deep linking on next login
      storeReturnUrl();
      
      const response = await descope.logout();
       if (response.error) {
         return Promise.reject(response.error);
       }
      return Promise.resolve();
    },
    async checkError() {
      return Promise.resolve();
    },
    async checkAuth(params) {
      console.log("checkAuth");
      console.log(params);

     // const token = (descope as any).getSessionToken();
      return Promise.resolve();
    },
    async getPermissions(params) {
      console.log("getPermissions");
      console.log(params);
      const token = (descope as any).getSessionToken();
      const perms = (descope as any).getJwtPermissions(token);
      console.log("perms");
      console.log(perms);
      return Promise.resolve(perms || []);
    },
    async getIdentity() {
      console.log("getIdentity");
   
      const me = await descope.me();
      console.log('me');
      console.log(me);
      const identity: UserIdentity = {
        id: me.data.userId,
        fullName: me.data.name
      };

      return Promise.resolve(identity);
    },
  };
};
